import { useState } from 'react';

export default function SolarFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does solar panel installation cost in El Paso?',
      answer: 'The average cost for residential solar installation in El Paso ranges from $15,000 to $30,000 before incentives, depending on system size and equipment quality. A typical 6kW system costs around $18,000-$22,000. After the 30% federal solar tax credit, costs drop to $12,600-$15,400. Additional state and local incentives may further reduce costs. Most homeowners see a payback period of 7-12 years with El Paso\'s abundant sunshine.'
    },
    {
      question: 'Is El Paso a good location for solar panels?',
      answer: 'Yes, El Paso is an excellent location for solar energy! With over 300 days of sunshine annually and an average of 3,800+ peak sun hours per year, El Paso ranks among the top cities in the U.S. for solar potential. The dry climate means minimal weather-related system downtime, and high electricity rates make solar savings even more attractive. El Paso\'s solar irradiance levels are ideal for maximizing energy production and ROI.'
    },
    {
      question: 'What solar incentives are available in El Paso?',
      answer: 'El Paso residents can benefit from several solar incentives: the 30% Federal Solar Investment Tax Credit (ITC) through 2032, Texas property tax exemption for solar installations (no increase in property taxes), sales tax exemption on solar equipment purchases, and net metering programs from El Paso Electric that credit you for excess power sent to the grid. Some local utilities also offer additional rebates for solar installations.'
    },
    {
      question: 'How long does solar panel installation take?',
      answer: 'The physical installation of a residential solar system typically takes 1-3 days. However, the entire process from contract signing to system activation usually takes 1-3 months. This timeline includes: site assessment and system design (1-2 weeks), permitting and utility approval (2-6 weeks), actual installation (1-3 days), inspection and interconnection approval (1-2 weeks). Your contractor will handle most of the paperwork and coordination.'
    },
    {
      question: 'Do solar panels work during power outages?',
      answer: 'Standard grid-tied solar systems automatically shut off during power outages for safety reasons (to protect utility workers). However, if you add battery storage to your system, you can have backup power during outages. Hybrid systems with batteries allow you to store excess solar energy and use it when the grid is down, providing energy independence and peace of mind during El Paso\'s occasional severe weather events.'
    },
    {
      question: 'How much can I save on electricity with solar panels?',
      answer: 'El Paso homeowners typically save $800-$1,500 per year on electricity bills with solar panels, depending on system size and energy usage. Over a 25-year system lifespan, total savings can reach $20,000-$40,000 or more. With El Paso Electric\'s net metering program, excess energy production is credited to your account, maximizing savings. Actual savings depend on your current electricity usage, system size, and future utility rate increases.'
    },
    {
      question: 'What maintenance do solar panels require?',
      answer: 'Solar panels require minimal maintenance. In El Paso\'s dusty climate, occasional cleaning (2-4 times per year) helps maintain optimal efficiency—rain often handles this naturally. Annual inspections to check connections, mounting hardware, and inverter performance are recommended. Most systems include monitoring software to track performance. Panel warranties typically last 25+ years, and inverters 10-15 years. Professional maintenance services are available if you prefer hands-off care.'
    },
    {
      question: 'Will solar panels increase my home value?',
      answer: 'Yes, solar panels typically increase home value. Studies show homes with solar sell for 3-4% more on average, which translates to an additional $10,000-$20,000 for median-priced El Paso homes. Solar homes also sell faster than comparable non-solar homes. In Texas, the property tax exemption means you gain the value increase without higher property taxes. Owned systems (not leased) provide the most value, as buyers appreciate the immediate energy savings.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about solar panel installation in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-amber-500 flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
